import { QueryClient, QueryClientProvider } from 'react-query';

// React Query v3 has no `networkMode`, so an offline query still fires its
// queryFn, fails, and retries (default `retry: 3`) — multiplied across every
// query a page mounts, that becomes a request storm while offline. Gate retries
// on `navigator.onLine`: when the browser reports no network, stop retrying.
// Online behaviour is unchanged (navigator.onLine is true → identical to the
// previous default of 3 retries). Per-query `retry` overrides still win.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount) => navigator.onLine && failureCount < 3,
    },
  },
});

export const QueryProvider = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
